import type {PerkUsagePreviewComponentProps} from '@cohort/merchants/apps';
import {Fragment} from 'react';

export const TypeformFormPerkIntegrationsUsagePreviewComponent: React.FC<
  PerkUsagePreviewComponentProps
> = () => <Fragment />;
